import React, { useMemo, useState, useEffect, memo } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { DataGrid } from '@mui/x-data-grid';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button';
import PaymentIcon from '@material-ui/icons/Payment';

const columns = [
  {
    field: 'num',
    width: 10,
    align: 'right',
    headerName: '#',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  { field: 'CardCode', width: 200, headerName: 'Código', hideable: false, sortable: false },
  { field: 'CardName', width: 400, headerName: 'Cliente / Proveedor', hideable: false, sortable: false },
  { field: 'base_zone_description', width: 200, headerName: 'Zona', hideable: false, sortable: false }
];

function PymtCustomerImport(props) {
  const { importData, setImportedData, setPayWithDocuments } = props;
  const { processing, onImport, paymentMethod, onProcessDocuments } = props;

  const dataGridColumns = useMemo(() => [...columns], []);

  const aviableDocumentsMapped = useMemo(() => {
    return (importData ?? []).map((item, i) => ({
      id: i + 1,
      CardCode: item.CardCode,
      CardName: item.CardName,
      base_zone_description: item.base_zone_description,
      num: i + 1,
    }));
  }, [importData]);

  useEffect(() => {
    const customersWithZones = (importData ?? []).map(item => {
      const customer = {
        CardCode: item.CardCode,
      };
      
      // Solo agregar base_zone_id si tiene un valor válido
      if (item.base_zone_id && item.base_zone_id !== '' && !isNaN(item.base_zone_id)) {
        customer.base_zone_id = parseInt(item.base_zone_id, 10);
      }
      
      return customer;
    });

    setImportedData(customersWithZones);
    setPayWithDocuments(true); // Cambiado a true para mostrar los documentos

    console.log("Clientes+Zonas importados: ", customersWithZones);
  }, [importData, setImportedData, setPayWithDocuments]);

  // Función para manejar el procesamiento de documentos
  const handleProcessDocuments = (e) => {
    e.preventDefault();
    if (onProcessDocuments) {
      onProcessDocuments();
    }
  };

  return (
    <CardContainer
      icon={null}
      style={{ height: '250px', marginTop: 10 }}
    >
      <DataGrid
        rowHeight={35}
        columns={dataGridColumns}
        disableSelectionOnClick
        rows={aviableDocumentsMapped}
      />
      <GridContainer justify="flex-end">
        <GridItem xs={6} lg={2}>
          <form id="formProcess" onSubmit={handleProcessDocuments}>
            <Button
              fullWidth
              type="submit"
              color="success"
              // disabled={processing || paymentMethod === null}
            >
              <PaymentIcon /> Procesar documentos importados
            </Button>
          </form>
        </GridItem>
        <GridItem xs={6} lg={2}>
          <Button
            fullWidth
            color="info"
            onClick={onImport}
          >
            <PaymentIcon /> Importar excel
          </Button>
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default memo(PymtCustomerImport);